<div class="password-guard-overlay">
  <div class="password-guard-container">
    <h2>請輸入驗証碼</h2>
    <form (ngSubmit)="checkPassword()" #passwordForm="ngForm">
      <div class="form-group">
        <input
          type="password"
          [(ngModel)]="password"
          name="password"
          placeholder="輸入驗証碼"
          required
          #passwordInput="ngModel"
          [class.error]="errorMessage"
        />
      </div>
      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>
      <button type="submit" [disabled]="!passwordForm.form.valid">確定</button>
    </form>
  </div>
</div>
